import React from 'react';
import type { BoxShape } from '../../types';
import { perimeterHitRects } from '../../utils/hitArea';

interface RectShapeProps {
  shape: BoxShape;
  isEditor?: boolean;
  isSelected?: boolean;
  scaledStrokeWidth?: number;
}

export const RectShape = React.memo(function RectShape({ shape, isEditor, isSelected, scaledStrokeWidth }: RectShapeProps) {
  return (
    <g data-shape-id={shape.id}>
      {isEditor && (isSelected ? (
        <rect
          x={shape.x - 0.015}
          y={shape.y - 0.015}
          width={shape.width + 0.03}
          height={shape.height + 0.03}
          fill="transparent"
          stroke="none"
          pointerEvents="fill"
          style={{ cursor: 'inherit' }}
        />
      ) : (
        perimeterHitRects(shape.x, shape.y, shape.width, shape.height, 0.015).map((r, i) => (
          <rect
            key={i}
            x={r.x}
            y={r.y}
            width={r.width}
            height={r.height}
            fill="transparent"
            stroke="none"
            pointerEvents="fill"
            style={{ cursor: 'inherit' }}
          />
        ))
      ))}
      <rect
        x={shape.x}
        y={shape.y}
        width={shape.width}
        height={shape.height}
        fill="none"
        stroke={shape.color}
        strokeWidth={scaledStrokeWidth ?? 2}
        vectorEffect={scaledStrokeWidth ? undefined : 'non-scaling-stroke'}
        pointerEvents="none"
      />
    </g>
  );
});
